module.exports = __webpack_public_path__ + "app/kiss-seller/division-254NBPDh.html";